import { render, staticRenderFns } from "./metric.vue?vue&type=template&id=5bcdf616"
import script from "./metric.vue?vue&type=script&lang=js"
export * from "./metric.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports